'use client';

import { useFlag } from '@unleash/nextjs/client'

import { FeatureFlag as FeatureFlagEnum } from "@/services/unleash/featureFlags";

export default function FeatureFlag(){
    return useFlag(FeatureFlagEnum.UNLEASH) ? (
        <div id="unleash" className="hidden" />
    ) : null;
}
